module.exports = __webpack_public_path__ + "img/video4.d6b1523c.jpg";